<div class="content">
  <img src="img/404NOTFOUND.png" alt="404 page not found" class="not-found-img" />
  <div class="not-found-description">Oops! page not found</div>
  <button mat-raised-button routerLink="">Go Home</button>
</div>
